import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Fragment, ReactNode } from "react";
import { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const ManualCalculationMethodDetails = ({ calculationMethod, hiddenFields, agreementType }: CalculationMethodDetailsByTypeProps) => {
	const ManualCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.customUnit",
			render: () => agreementType === AgreementTypeEnum.PostCalculation && (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "POST_CALCULATION_CUSTOM_UNIT" })} overflow="visible">
						{calculationMethod.customUnit || "-"}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.description",
			render: () => (
				<Grid size={12}>
					<FormGroup label={intl.formatMessage({ id: "MANUAL_TEXT" })} overflow="visible">
						{calculationMethod.description || "-"}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{ManualCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default ManualCalculationMethodDetails;
